import { NeedDto } from '@act/shared/data-transfer-objects';
import { membersAppSelectors } from 'redux/slices/memberSlice';
import { ChipColor, TaggableChip } from '@act/storybook';
import syvaNeedsUtils from '../syvaNeeds.util';

interface NeedStatusTagProps {
  need: NeedDto;
}

const NeedStatusTag = ({ need }: NeedStatusTagProps) => {
  const member = membersAppSelectors.useSelectMemberById(need.memberId);
  const label = syvaNeedsUtils.calculateNeedLabel(need, member);
  let color: ChipColor = 'neutral';
  let saturated: boolean = false;
  if (label === 'Fulfilled') {
    color = 'success';
    saturated = true;
  } else if (label === 'Unresolved') {
    color = 'error';
    saturated = true;
  } else if (label === 'Stopped pursuing') {
    color = 'warning';
  }
  return (
    <TaggableChip label={label} color={color} isTag isSaturated={saturated} />
  );
};

export default NeedStatusTag;
